var path = 'directives/footnotes/footnotes.html';
var html = "<div class=\"box full-post\" ng-if=vm.footnotes.length ng-class=\"{ geomulti: vm.geomulti }\"><h5>Footnotes</h5><ol><li ng-repeat=\"note in vm.footnotes track by $index\" ng-attr-id=\"{{ 'note-' + note.id }}\" ng-bind-html=\"note.note | markdown\" ng-attr-data-list-character=\"{{ note.label }}\"></li></ol></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./js/directives/footnotes/footnotes.html
 ** module id = 189
 ** module chunks = 0
 **/